const styles = {
  formLabel: {
    color: '#000',
    textAlign: 'left',
    fontFamily: 'YuGothic',
    fontSize: 16,
    lineHeight: '24px',
    '.MuiFormLabel-asterisk': {
      fontWeight: 'bold',
      color: '#ff0000'
    }
  },
  confirmValue: {
    color: '#000',
    textAlign: 'left',
    fontFamily: 'YuGothic',
    fontSize: 16,
    lineHeight: '24px',
    padding: '0 6px',
  },
  textField: {
    height: 30,
    padding: '0 16px',
  },
  button: {
    backgroundColor: '#2980B9',
    minWidth: 120,
    height: 34,
    fontSize: 18,
    fontWeight: 700,
    color: '#fff',
    fontFamily: 'YuGothic',
    padding: '0 16px',
    '&:hover': {
      background: '#2980B9',
    }
  },
  outline: {
    backgroundColor: '#fff',
    border: '1px solid #2980B9',
    color: '#2980B9',
    '&:hover': {
      background: '#fff',
    }
  },
};

export default styles;